import gsap from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Basics, isMobile } from '../_app/cuchillo/core/Basics';

let Z_INDEX = 0;

export class ScrollItem__BlockCarsFeatured extends ScrollItem__BlockDefault {
    controls;
    slides = [];
    current = -1;
    timerId;
    looping = false;

    _calls = {
        change: (e) => this.change(e)
    }

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.controls = GetBy.selector('.__controls button', __link);

        for (let i = 0; i < this.controls.length; i++) {
            this.slides.push(new SlideFeatured(i, __link));
            this.controls[i].addEventListener(Basics.clickEvent, this._calls.change);
        }
    }

    showFunction() {
        super.showFunction();

        if (this.current < 0) {
            this.slides[0].show();
            this.current = 0;
            this.item.style.setProperty('--current', 0);

            this.looping = true;
            this.timerId = setInterval(() => {
                this.loop()
            }, 3000);
        }
    }

    change(e) {
        if (this.looping) {
            this.looping = false;
            clearInterval(this.timerId);
        }

        const index = parseInt(e.target.dataset.index);

        console.log('CHANGE', index);

        this.slides[this.current].hide();
        this.slides[index].show();
        this.item.style.setProperty('--current', index);

        this.current = index;
    }

    // hideFunction() {
    //     super.hideFunction();
    //     gsap.ticker.remove(this._calls.loop);
    // }

    loop() {
        this.slides[this.current].hide();

        if (this.current + 1 < this.slides.length) {
            this.slides[this.current + 1].show();
            this.current++;
        } else {
            this.slides[0].show();
            this.current = 0
        }

        this.item.style.setProperty('--current', this.current);
    }

    dispose() {
        for (let i = 0; i < this.controls.length; i++) {
            this.controls[0].removeEventListener(Basics.clickEvent, this._calls.change);
        }

        super.dispose();
    }
}

Scroll._registerClass('BlockCarsFeatured', ScrollItem__BlockCarsFeatured);

class SlideFeatured {
    leftImage;
    rightImage;
    leftWrapper;
    rightWrapper;
    index;
    button;
    cta;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__i, __parent) {
        this.index = __i;
        this.parent = __parent;

        this.leftWrapper = GetBy.selector('.__left .img', __parent)[__i];
        this.leftImage = GetBy.selector('.__left img', __parent)[__i];
        this.rightWrapper = GetBy.selector('.__right .img', __parent)[__i];
        this.rightImage = GetBy.selector('.__right img', __parent)[__i];
        this.button = GetBy.selector(`button[data-index="${this.index}"]`, __parent)[0];
        this.cta = GetBy.selector(`a[data-index="${this.index}"]`, __parent)[0];

        this.directHide();
    }

    //==================================================================================================================
    //          PUBLIC
    //==================================================================================================================
    directHide() {
        if (!isMobile) gsap.set(this.leftWrapper, { y: '101%' });
        gsap.set(this.rightWrapper, { y: '101%' });

        if (!isMobile) gsap.set(this.leftImage, { scale: 1.4 });
        gsap.set(this.rightImage, { scale: 1.4 });

        this.button.parentNode.classList.remove('--active');
        this.cta.style.display = 'none';
    }

    show() {
        if (!isMobile) gsap.set(this.leftWrapper, { y: '101%' });
        gsap.set(this.rightWrapper, { y: '101%' });

        if (!isMobile) gsap.set(this.leftImage, { scale: 1.4 });
        gsap.set(this.rightImage, { scale: 1.4 });

        if (!isMobile) gsap.to(this.leftWrapper, { y: 0, duration: 1, ease: Ease.EASE_CUCHILLO_OUT });
        gsap.to(this.rightWrapper, { y: 0, duration: 1, ease: Ease.EASE_CUCHILLO_OUT });

        if (!isMobile) gsap.to(this.leftImage, { duration: 1.2, scale: 1.2, delay: .2, ease: Ease.EASE_CUCHILLO_OUT });
        gsap.to(this.rightImage, { duration: 1.2, scale: 1.2, delay: .2, ease: Ease.EASE_CUCHILLO_OUT });

        this.button.parentNode.classList.add('--active');
        this.cta.style.display = 'inline-flex';

        Z_INDEX++;
        if (!isMobile) this.leftWrapper.style.zIndex = Z_INDEX;
        this.rightWrapper.style.zIndex = Z_INDEX;
    }

    hide() {
        if (!isMobile) gsap.set(this.leftImage, { scale: 1.2 });
        gsap.set(this.rightImage, { scale: 1.2 });

        if (!isMobile) gsap.to(this.leftImage, { scale: 1, duration: 1, ease: Ease.EASE_CUCHILLO_OUT });
        gsap.to(this.rightImage, { scale: 1, duration: 1, ease: Ease.EASE_CUCHILLO_OUT });

        this.button.parentNode.classList.remove('--active');
        this.cta.style.display = 'none';
    }
}
